import { Box } from '@mui/material';
import { BalenaDeviceCardLastSeen } from './BalenaDeviceCardLastSeen';
import { BalenaDeviceIdCopyButton } from './BalenaDeviceIdCopyButton';

/**
 * Card footer: device id (copyable) on the left, last-seen (offline only) on the right.
 */
export function BalenaDeviceCardFooter({
  deviceId,
  isOnline,
  lastSeenOnline,
}: {
  deviceId: number;
  isOnline: boolean;
  lastSeenOnline?: string;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        px: 2,
        pb: 1.5,
        pt: 1,
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <BalenaDeviceIdCopyButton deviceId={deviceId} />
      <BalenaDeviceCardLastSeen isOnline={isOnline} lastSeenOnline={lastSeenOnline} />
    </Box>
  );
}
